import { connect } from 'react-redux';

import { IInfrastructureDispatchProps, IInfrastructureProps, Infrastructure } from './index';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { TTypedThunkDispatch } from '../../types/store';
import { getInfrastructureElementsStrings } from '../../utils/get_infrastructure_list';

export function mapStateToProps(state: IState): IInfrastructureProps {
  const { communicationSet, infrastructureList } = state.villageData.village;

  return {
    infrastructureList: getInfrastructureElementsStrings(infrastructureList, communicationSet),
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IInfrastructureDispatchProps {
  return {
    setNavigationLink: () => dispatch(setNavigationLink(NavigationLinkTypes.Infrastructure)),
  };
}

export const InfrastructureContainer = connect<IInfrastructureProps, IInfrastructureDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Infrastructure);
